function a(e) {
  const r = new TextEncoder().encode(e), t = Array.from(r, (o) => String.fromCharCode(o)).join("");
  return btoa(t);
}
async function c(e) {
  if (e.order.outcome === "ready")
    try {
      const { origin: r } = new URL(e.sourceUrl ?? ""), t = a(JSON.stringify({ order: e.order }));
      if (`${r}/pages/just-post-purchase?data=${t}`.length > 2e3) {
        const o = await fetch(process.env.NEXT_PUBLIC_PASSTHROUGH_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ data: t })
        }).then((n) => n.json());
        location.href = `${r}/pages/just-post-purchase?passthrough=${encodeURIComponent(o.createdId)}`;
      } else
        location.href = `${r}/pages/just-post-purchase?data=${encodeURIComponent(t)}`;
    } catch {
      window.location.replace(e.order.url);
    }
}
function s() {
  return {
    redirectToOrderPage: c
  };
}
function d(e) {
  if (e === "shopify")
    return s();
}
export {
  d as getCMSInterceptors
};
